import { useFloatingEditorState } from '../hooks/useFloatingEditorState';
import { AsyncComposeEditor } from './AsyncComposeEditor';
import { FloatingComposeEditorWrapper } from './FloatingComposeEditorWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const ClassicFloatingComposeEditor = ({
  associations,
  onSend = () => {},
  inboxId,
  renderExistingFileSelect,
  useWhatsAppCompose,
  defaultMessageValue
}) => {
  const {
    isOpen,
    close
  } = useFloatingEditorState();
  if (isOpen) {
    return /*#__PURE__*/_jsx("div", {
      className: "floating-components__container",
      children: /*#__PURE__*/_jsx("div", {
        className: "floating-components__component",
        children: /*#__PURE__*/_jsx(AsyncComposeEditor, {
          associations: associations,
          onClose: close,
          onSend: onSend,
          onSendStart: close,
          inboxId: inboxId,
          useWhatsAppCompose: useWhatsAppCompose,
          renderExistingFileSelect: renderExistingFileSelect,
          StyledWrapper: FloatingComposeEditorWrapper,
          defaultMessageValue: defaultMessageValue
        })
      })
    });
  }
  return null;
};
ClassicFloatingComposeEditor.displayName = 'ClassicFloatingComposeEditor';